import { useState } from 'react';
import { Column } from '@simplywallst/ui-core';
import { Menu } from './styled';
import loadable from '@loadable/component';

const SideMenu = loadable(() => import('./components/SideMenu'), {
  resolveComponent: (component) => component.SideMenu,
});

interface Props {
  isWhite?: boolean;
}

export const MobileNav = ({ isWhite }: Props) => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <Column
      displayFlex
      justifyContent="flex-end"
      alignItem="center"
      col={6}
      colMd={10}
    >
      <Menu
        onClick={() => {
          setShowMenu(true);
        }}
        $isWhite={isWhite}
      />
      <SideMenu show={showMenu} onClose={() => setShowMenu(false)} />
    </Column>
  );
};
